import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';

// import productPCX from '@/pages/productPCX';
// import productPCXManage from '@/pages/productPCXManage';

Vue.use(Router);

export default new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login'),
    },
    {
      path: '/',
      name: 'zj-layout',
      redirect: '/wallet/details',
      component: () => import('@/components/layout'),
      meta: {
        login: true,
      },
      children: [
        {
          // 派发优惠券
          path: '/wallet/coupons/distributingCoupons',
          name: 'DistributingCoupons',
          component: () => import('@/pages/coupons/view/distributingCoupons.vue'),
          meta: {
            login: true,
            agentFlag: true,
            adminFlag: false,
          },
        },
        {
          path: '/wallet',
          name: 'walletIndex',
          redirect: '/wallet/details',
          component: () => import('@/pages/wallet/wallet.vue'),
          meta: {
            login: true,
            agentFlag: true,
            adminFlag: true,
          },
          children: [
            {
              path: '/walletLeftNav',
              name: 'walletLeftNav',
              component: () => import('@/components/walletLeftNav'),
              meta: {
                login: true,
                agentFlag: true,
                adminFlag: true,
              },
              children: [
                {
                  path: '/wallet/salesOperationData',
                  name: 'statistics',
                  component: () => import('@/pages/wallet/salesOperationData.vue'),
                  meta: {
                    // login: true,
                    login: false,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/salesBySubject',
                  name: 'salesBySubject',
                  component: () => import('@/pages/wallet/salesBySubject.vue'),
                  meta: {
                    // login: true,
                    login: false,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/salesServiceData',
                  name: 'salesServiceData',
                  component: () => import('@/pages/wallet/salesServiceData.vue'),
                  meta: {
                    // login: true,
                    login: false,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/courseSales',
                  name: 'courseSales',
                  component: () => import('@/pages/wallet/courseSales.vue'),
                  meta: {
                    // login: true,
                    login: false,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/statistics',
                  name: 'statistics',
                  component: () => import('@/pages/wallet/statistics.vue'),
                  meta: {
                    // login: true,
                    login: false,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/details',
                  name: 'walletDetails',
                  component: () => import('@/pages/wallet/details.vue'),
                  meta: {
                    // login: true,
                    login: false,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/recommend',
                  name: 'walletRecommend',
                  component: () => import('@/pages/wallet/recommend.vue'),
                  meta: {
                    // login: true,
                    login: false,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/weixinbind',
                  name: 'walletWeixinbind',
                  component: () => import('@/pages/wallet/weixinbind.vue'),
                  meta: {
                    // login: true,
                    login: false,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/weixinbind-test',
                  name: 'walletWeixinbindTest',
                  component: () => import('@/pages/wallet/weixinbindTest.vue'),
                  meta: {
                    // login: true,
                    login: false,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/weixinprofit',
                  name: 'walletWeixinprofit',
                  component: () => import('@/pages/wallet/weixinprofit.vue'),
                  meta: {
                    // login: true,
                    login: false,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/agentPay',
                  name: 'walletAgentPay',
                  component: () => import('@/pages/wallet/agentPay.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/renewalAuthority',
                  name: 'renewalAuthority',
                  component: () => import('@/pages/wallet/renewalAuthority.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/renewalRecord',
                  name: 'renewalRecord',
                  component: () => import('@/pages/wallet/renewalRecord.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                //批量续费
                {
                  path: '/wallet/batchRenewal',
                  name: 'batchRenewal',
                  component: () => import('@/pages/wallet/batchRenewal.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/payRecord',
                  name: 'walletPayRecord',
                  component: () => import('@/pages/wallet/payRecord.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/transactionRecord',
                  name: 'walletTransactionRecord',
                  component: () => import('@/pages/wallet/transactionRecord.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/orders',
                  name: 'myOrders',
                  component: () => import('@/pages/wallet/MyOrders.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/payApproval',
                  name: 'walletPayApproval',
                  component: () => import('@/pages/wallet/payApproval.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/settingArrears',
                  name: 'walletSettingArrears',
                  component: () => import('@/pages/wallet/settingArrears.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/bank',
                  name: 'walletBank',
                  component: () => import('@/pages/wallet/bank.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
                {
                  path: '/wallet/coupons',
                  name: 'Coupons',
                  redirect: {
                    name: 'CouponsManage',
                  },
                  component: () => import('@/pages/coupons/index.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                  children: [
                    {
                      path: '/wallet/coupons/couponsManage',
                      name: 'CouponsManage',
                      component: () => import('@/pages/coupons/view/manage.vue'),
                      meta: {
                        login: true,
                        agentFlag: true,
                        adminFlag: false,
                      },
                    },
                    {
                      path: '/wallet/coupons/couponsLog',
                      name: 'CouponsLog',
                      component: () => import('@/pages/coupons/view/couponsLog.vue'),
                      meta: {
                        login: true,
                        agentFlag: true,
                        adminFlag: false,
                      },
                    },
                    {
                      path: '/wallet/coupons/stuManage',
                      name: 'CouponsStuManage',
                      component: () => import('@/pages/coupons/view/stuManage.vue'),
                      meta: {
                        login: true,
                        agentFlag: true,
                        adminFlag: false,
                      },
                    },
                  ],
                },
                {
                  // 编辑优惠券
                  path: '/wallet/coupons/editCoupon',
                  name: 'EditCoupon',
                  component: () => import('@/pages/coupons/view/editCoupon.vue'),
                  meta: {
                    login: true,
                    agentFlag: true,
                    adminFlag: false,
                  },
                },
              ],
            },
            {
              path: '/wallet/recharge',
              name: 'walletRecharge',
              component: () => import('@/pages/wallet/recharge.vue'),
              meta: {
                login: true,
                agentFlag: true,
                adminFlag: true,
              },
            },
            {
              path: '/wallet/asdrecharge',
              name: 'walletASDRecharge',
              component: () => import('@/pages/aisudu/walletASDRecharge'),
              meta: {
                login: true,
                agentFlag: true,
                adminFlag: true,
              },
            },
            {
              path: '/wallet/rechargeBack',
              name: 'walletRechargeBack',
              component: () => import('@/pages/wallet/rechargeBack.vue'),
              meta: {
                login: true,
                agentFlag: true,
                adminFlag: true,
              },
            },
            {
              path: '/wallet/refund',
              name: 'walletRefund',
              component: () => import('@/pages/wallet/refund.vue'),
              meta: {
                login: true,
                agentFlag: true,
                adminFlag: true,
              },
            },
            {
              path: '/wallet/backRecharge',
              name: 'backRecharge',
              component: () => import('@/pages/backRecharge'),
              meta: {
                login: true,
                agentFlag: true,
                adminFlag: true,
              },
            },
            {
              path: '/wallet/withdraw',
              name: 'withdrawApplication',
              component: () => import('@/pages/wallet/withdrawApplication.vue'),
              meta: {
                login: true,
                agentFlag: true,
                adminFlag: true,
              },
            },
            {
              path: '/wallet/arrearsRecord',
              name: 'arrearsRecord',
              component: () => import('@/pages/wallet/arrearsRecord.vue'),
              meta: {
                login: true,
                agentFlag: true,
                adminFlag: true,
              },
            },
            {
              path: '/wallet/teacherOperatingRecord',
              name: 'teacherOperatingRecord',
              component: () => import('@/pages/wallet/teacherOperatingRecord.vue'),
              meta: {
                login: true,
                agentFlag: true,
                adminFlag: false,
              },
            },
          ],
        },
        {
          path: '/product',
          name: 'productCenter',
          redirect: '/product/PCX',
          component: () => import('@/pages/productCenter'),
          meta: {
            login: true,
            agentFlag: true,
            adminFlag: false,
          },
          children: [
            {
              path: '/product/PCX',
              name: 'productPCX',
              component: () => import('@/pages/productPCX'),
              meta: {
                login: true,
                agentFlag: true,
                adminFlag: false,
              },
            },
          ],
        },
        {
          path: '/manage',
          name: 'manage',
          component: () => import('@/pages/manageCenter'),
          meta: {
            login: true,
            agentFlag: false,
            adminFlag: true,
          },
          children: [
            {
              path: '/manage/product',
              name: 'manageProduct',
              redirect: '/manage/product/PCX',
              component: () => import('@/components/manageProductCenter'),
              meta: {
                name: '产品管理',
                login: true,
                agentFlag: false,
                adminFlag: true,
                adminRole: [0, 1, 2],
              },
              children: [
                // {
                //     path: '/manage/product/PCX',
                //     name: 'manageProductPCX',
                //     component: () =>
                //         import ('@/pages/manageProductPCX'),
                //     meta: {
                //         name: '评测学',
                //         productCode: 'PCX',
                //         login: true,
                //         agentFlag: false,
                //         adminFlag: true,
                //         adminRole: [0, 1, 2]
                //     }
                // },
                {
                  path: '/manage/product/ASD',
                  name: 'manageProductASD',
                  component: () => import('@/pages/aisudu/manageProductASD'),
                  meta: {
                    name: '艾速度',
                    productCode: 'ASD',
                    login: true,
                    agentFlag: false,
                    adminFlag: true,
                    adminRole: [0, 1, 2],
                  },
                },
                {
                  path: '/manage/product/CPX',
                  name: 'manageProductCPX',
                  component: () => import('@/pages/aisudu/manageProductCPX'),
                  meta: {
                    name: '评测学',
                    productCode: 'CPX',
                    login: true,
                    agentFlag: false,
                    adminFlag: true,
                    adminRole: [0, 1, 2],
                  },
                },
                {
                  path: '/manage/product/AIQA',
                  name: 'manageProductAIQA',
                  component: () => import('@/pages/aiqa/manageProductAIQA'),
                  meta: {
                    name: '智能答疑',
                    productCode: 'AIQA',
                    login: true,
                    agentFlag: false,
                    adminFlag: true,
                    adminRole: [0, 1, 2],
                  },
                },
                {
                  path: '/manage/product/SS',
                  name: 'manageProductSS',
                  component: () => import('@/pages/manageProductSS'),
                  meta: {
                    name: '远程督导',
                    productCode: 'SS',
                    login: true,
                    agentFlag: false,
                    adminFlag: true,
                    adminRole: [0, 1, 2],
                  },
                },
                // {
                //   path: '/manage/product/PN',
                //   name: 'manageProductPN',
                //   component: () => import('@/pages/pennonedu/manageProductPN'),
                //   meta: {
                //     name: '培诺',
                //     productCode: 'PN',
                //     login: true,
                //     agentFlag: false,
                //     adminFlag: true,
                //     adminRole: [0, 1, 2]
                //   }
                // },
              ],
            },
            {
              path: '/manage/order',
              name: 'manageOrder',
              component: () => import('@/components/manageOrder'),
              meta: {
                name: '转账工单',
                login: true,
                agentFlag: false,
                adminFlag: true,
                adminRole: [0, 1, 3, 4],
              },
              children: [
                {
                  path: '/manage/order/application',
                  name: 'orderApplication',
                  component: () => import('@/pages/manageOrderApplication'),
                  meta: {
                    name: '申请单',
                    login: true,
                    agentFlag: false,
                    adminFlag: true,
                    adminRole: [0, 1, 4],
                  },
                },
                {
                  path: '/manage/order/review',
                  name: 'orderReview',
                  component: () => import('@/pages/manageOrderReview'),
                  meta: {
                    name: '审核单',
                    login: true,
                    agentFlag: false,
                    adminFlag: true,
                    adminRole: [0, 1, 3],
                  },
                },
              ],
            },
            {
              path: '/manage/withdraw',
              name: 'manageWithdraw',
              component: () => import('@/components/manageOrder'),
              meta: {
                name: '提现管理',
                login: true,
                agentFlag: false,
                adminFlag: true,
                adminRole: [0, 1, 3, 4],
              },
              children: [
                {
                  path: '/manage/withdraw/aisudu',
                  name: 'manageWithdrawAisudu',
                  component: () => import('@/pages/manage/withdraw.vue'),
                  meta: {
                    name: '艾速度提现',
                    login: true,
                    agentFlag: false,
                    adminFlag: true,
                    adminRole: [0, 1, 3, 4],
                  },
                },
              ],
            },
            {
              path: '/manage/user',
              name: 'manageUser',
              component: () => import('@/components/manageUser'),
              meta: {
                name: '用户中心',
                adminRole: [0, 1],
              },
              children: [
                {
                  path: '/manage/user/index',
                  name: 'userIndex',
                  component: () => import('@/pages/manageUser'),
                  meta: {
                    name: '用户管理',
                    login: true,
                    agentFlag: false,
                    adminFlag: true,
                    adminRole: [0, 1],
                  },
                },
              ],
            },
            {
              path: '/manage/recommend',
              name: 'manageRecommend',
              component: () => import('@/components/manageUser'),
              meta: {
                name: '推荐管理',
                adminRole: [0, 1],
              },
              children: [
                {
                  path: '/manage/recommend/manageRecommendAmbassador',
                  name: 'manageRecommendAmbassador',
                  component: () => import('@/pages/manageRecommendAmbassador'),
                  meta: {
                    name: '管理推荐大使',
                    login: true,
                    agentFlag: false,
                    adminFlag: true,
                    adminRole: [0, 1],
                  },
                },
              ],
            },
          ],
        },
        {
          path: '/renew',
          name: 'renew',
          component: () => import('@/pages/renew'),
          meta: {
            login: true,
            agentFlag: true,
            adminFlag: false,
          },
        },
        {
          path: '/asdrenew',
          name: 'asdrenew',
          component: () => import('@/pages/aisudu/asdrenew'),
          meta: {
            login: true,
            agentFlag: true,
            adminFlag: false,
          },
        },
        {
          path: '/allAsdrenew',
          name: 'allAsdrenew',
          component: () => import('@/pages/aisudu/allAsdrenew'),
          meta: {
            login: true,
            agentFlag: true,
            adminFlag: false,
          },
        },
        {
          path: '/back/fixWalletState',
          name: 'fixWalletState',
          component: () => import('@/pages/fixWalletState.vue'),
          meta: {
            login: true,
            agentFlag: false,
            adminFlag: true,
          },
        },
        {
          path: '/back/index',
          name: 'backIndex',
          component: () => import('@/pages/manage/index.vue'),
          meta: {
            login: true,
            agentFlag: false,
            adminFlag: true,
          },
        },
        {
          path: '/403',
          name: '403Forbidden',
          component: () => import('@/components/403Forbidden'),
          meta: {
            login: false,
            agentFlag: false,
          },
        },
      ],
    },
    {
      //学生智能答疑
      path: '/stuAnsweringQuestion',
      name: 'stuAnsweringQuestion',
      redirect: '/stuAnsweringQuestion/wallet',
      component: () => import('@/pages/stuAnsweringQuestion/stuAnsweringQuestion'),
      // meta: {
      //   login: false,
      //   agentFlag: true,
      //   adminFlag: false
      // },
      children: [
        {
          path: '/stuAnsweringQuestion/wallet',
          component: () => import('@/pages/stuAnsweringQuestion/wallet'),
        },
        {
          path: '/stuAnsweringQuestion/record',
          component: () => import('@/pages/stuAnsweringQuestion/record'),
        },
        {
          path: '/stuAnsweringQuestion/recharge',
          component: () => import('@/pages/stuAnsweringQuestion/recharge'),
        },
      ],
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/pages/404'),
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: () => import('@/pages/paySuccess'),
    },
  ],
});

/*页面刷新重新赋值commmon*/
//给公共参数重新赋值
if (hgetStore('hvuex')) {
  store.dispatch('hvuex', JSON.parse(hgetStore('hvuex')));
}

// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

//方便修改
export async function hvuex(obj) {
  return store.dispatch('hvuex', obj);
}
window.hvuex = hvuex;



// WEBPACK FOOTER //
// ./src/router/index.js